export default function notificationDescription(notification) {
    const MESSAGES = {
        'amendments_submitted' : {
            title : 'Your application amendments have been submitted',
            description : notification.body,
            link : getApplicationLink(notification),
        },
        'approved_for_payment' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'application_completed' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'documents_received' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'documents_requested' : {
            title : 'Application Status Updated',
            description : notification.body,
            link : getApplicationLink(notification)
        },
        'offer_accepted' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'claim_processed' : {
            title : 'Application Status Updated',
            description : notification.body,
            link : getApplicationLink(notification)
        },
        'offer_letter_sent' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'offer_rejected' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'submitted_for_payment' : {
            title : 'Application Status Updated',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'admin_comments_application' : {
            title : 'Your application has received comments',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'application_accepted' : {
            title : 'Your application has been accepted',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'amendments_required' : {
            title : 'Your application requires amendments',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'application_rejected' : {
            title : 'Your application has been rejected',
            description: notification.body,
            link : getApplicationLink(notification)
        },
        'application_submitted' : {
            title : 'Application Submitted',
            description: notification.body,
            link : getApplicationLink(notification)
        }
    };

    return MESSAGES[notification.title] ? MESSAGES[notification.title] : {
        title : formatTitle(notification),
        description : notification.body,
    } ;
}

function formatTitle(notification) {
    return notification.title.split('_').join(' ');
}

function getApplicationLink(notification) {
    if (notification.meta.id) {
        return `/myeb/grants/applications/${notification.meta.id}`;
    }
    else {
        return null;
    }

}
